// Forma de pagamento de uma parcela — usada só na baixa (não no lançamento em si, que ainda
// não tem certeza de como vai ser pago).
export const FINANCE_PAYMENT_METHODS = [
    { value: 'boleto', label: 'Boleto' },
    { value: 'pix', label: 'PIX' },
    { value: 'transferencia', label: 'Transferência' },
    { value: 'dinheiro', label: 'Dinheiro' },
    { value: 'cartao', label: 'Cartão' },
    { value: 'cheque', label: 'Cheque' },
]

export const FINANCE_STATUS_LABEL = {
    aberto: 'Em aberto',
    pago: 'Pago',
    atrasado: 'Atrasado',
    cancelado: 'Cancelado',
}
